export default {
  simple: {
    inputs: {
      search: 'Search',
      searchPlaceholder: 'Title keyword',
      searchPlaceholderExhibitor: 'Name keyword',
      in: 'In',
      among: 'Among'
    },
    buttons: {
      search: 'Search',
      advancedSearch: 'Advanced search'
    },
    data: {
      type: [
        { label: 'Exhibitions', value: 'exhibition' },
        { label: 'Exhibitors', value: 'exhibitor' },
        { label: 'Exhibited works', value: 'exhibited_work' }
      ],
      allCollections: 'All Collections',
      collections: [
        { label: 'All collections', value: 'all' },
        { label: 'Documenta', value: '4' },
        { label: 'Trienial', value: '3' },
        { label: 'Bienial', value: '2' },
        { label: 'Simple exhibition', value: '1' },
        { label: 'Salon', value: '5' }
      ]
    },
    popup: {
      exhibition: 'Un même artiste peut être orthographié de différentes manières selon les catalogues, ce qui peut restreindre les résultats de la recherche.',
      simpleExhibition: 'Une exposition simple est une exposition qui ne revient pas régulièrement au contraire d’un Salon, d’une biennale, d’une triennale ou d’une Documenta.'
    }
  },
  advanced: {
    title: 'Advanced search',
    reset: 'Reset form',
    search: 'Search',
    searchIn: 'Search in',
    among: 'among',
    keyword: 'keywords',
    and: 'AND',
    or: 'OR',
    orTitle: 'or',
    removeCriteria: 'Remove this criteria',
    addCriteria: 'Add a search term',
    yearPlaceholder: 'YYYY',
    resetPopup: {
      title: 'Warning',
      message: 'All data will be lost',
      ok: 'OK',
      cancel: 'Cancel'
    },
    selectCountriesFirstOption: 'Select a country',
    selectExhib_groupsFirstOption: 'Select an exhibition_group'
  },
  query: {
    exhibited_work: 'exhibited works',
    exhibition: 'exhibitions',
    exhibitor: 'exhibitors'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en_GB/forms.js